import { now } from 'owa-datetime';
import updateCurrentRenderedQueryString from 'owa-readwrite-recipient-well/lib/actions/updateCurrentRenderedQueryString';
import {
    populateFeedbackStateCache,
    resetFeedbackState,
} from 'owa-readwrite-recipient-well/lib/utils/populateFeedbackState';
import getAndPopulateSuggestedContacts from 'owa-recipient-cache/lib/actions/getAndPopulateSuggestedContacts';
import addLocalCacheTransactionComplete from 'owa-recipient-common/lib/utils/addLocalCacheTransactionComplete';
import getPersonasFromReadWriteRecipientList from 'owa-recipient-common/lib/utils/getPersonasFromReadWriteRecipientList';
import FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('getCacheZeroQuery')(async function getCacheZeroQuery(
    recipientWell: FindControlViewState | RecipientWellWithFindControlViewState,
    recipientsToExclude: ReadWriteRecipientViewState[],
    fallback?: boolean
): Promise<void> {
    updateCurrentRenderedQueryString(recipientWell, '');
    const transactionStartTime = now();
    resetFeedbackState(recipientWell);
    getAndPopulateSuggestedContacts(
        recipientWell.findResultSet,
        getPersonasFromReadWriteRecipientList(recipientsToExclude)
    );
    addLocalCacheTransactionComplete(recipientWell, transactionStartTime);

    populateFeedbackStateCache(
        recipientWell,
        transactionStartTime,
        recipientWell.findResultSet,
        fallback
    );
});
